import { render, staticRenderFns } from "./Col10.vue?vue&type=template&id=c3fb27ec&scoped=true"
import script from "./Col10.vue?vue&type=script&lang=js"
export * from "./Col10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb27ec",
  null
  
)

export default component.exports